var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"squander-wealth-container"},[_c('h2',[_vm._v("Squander Your Wealth... Its Fun")]),_c('div',{staticClass:"inner-container"},[_c('RWPurchases'),_c('RichestContainer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }